import { Component, OnInit } from '@angular/core';
import {VnaServicesService} from '../../../service/vna-services.service';

@Component({
  selector: 'app-list-services',
  templateUrl: './list-services.component.html',
  styleUrls: ['./list-services.component.scss']
})
export class ListServicesComponent implements OnInit {

    loading: boolean = false;
    services: Array<Object> = [];

    constructor(private servicesHandler: VnaServicesService) { }

    ngOnInit() {
        this.loading = true;
        this.servicesHandler.getVnaServices().subscribe(
            (r: Array<object>) => {
                this.services = r;
                this.loading = false;
            }
        )
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/services/list-services/list-services.component.ts